import { IFinanceOperatorsItem } from 'entities/financeOperations/types';

export const useUpdateFinanceOperatorReasonDefaultValue = (financeOperator: IFinanceOperatorsItem) => ({
  unavailable_until_at: financeOperator.downtime.unavailable_until_at,
  is_active: financeOperator.downtime.is_active,
  reason_id: financeOperator.downtime.reason_id,
});
